import React from 'react';
import {
  List,
  Show,
  TextInput,
  ReferenceManyField,
  RichTextField,
  TabbedShowLayout,
  Datagrid,
  EmailField,
  TextField,
  DateField,
  EditButton,
  ShowButton,
  RefreshButton,
  CardActions,
  Create,
  Tab,
  SimpleForm,
  ImageInput,
  ImageField,
  required,
} from 'react-admin';
import Icon from '@material-ui/icons/Star';
import RichTextInput from 'ra-input-rich-text';
import FullNameField from 'components/FullNameField';
import ImageGridField from 'components/ImageGridField';
import GridList from './GridList';
import Title from './Title';
import UploadToolbar from 'components/UploadToolbar';
import PictureNote from 'components/PictureNote';
// import CreateForm from './CreateForm';
import EditForm from './EditForm';

export const CarBrandIcon = Icon;

const validateMobile = values => {
  const errors = {};
  if (values.mobile && !values.mobile.startsWith('+')) {
    errors.mobile = ['Mobile should start with +'];
  }
  return errors;
};

const ListActions = () => {
  return (
    <CardActions>
      <RefreshButton />
    </CardActions>
  );
};

export const CarBrandList = props => (
  <List title="Car Brands" bulkActionButtons={false} actions={<ListActions />} {...props}>
    <GridList />
  </List>
);

export const CarBrandShow = props => (
  <Show {...props}>
    <TabbedShowLayout>
      <Tab label="Information">
        <TextField source="name" />
        <TextField source="mobile" />
        <ImageField source="logo_url" title="Logo" />
        <RichTextField source="description" />
        <DateField label="Created date" showTime={true} source="created_at" />
        <DateField label="Updated date" showTime={true} source="updated_at" />
      </Tab>
      <Tab label="Models">
        <ReferenceManyField addLabel={false} sort={{ field: 'name' }} reference="models" target="car_brand_id">
          <Datagrid>
            <TextField source="name" />
            <ImageGridField source="img_url" title="title" label="Images" />
            <ShowButton />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
      <Tab label="Contact Infos">
        <ReferenceManyField addLabel={false} reference="contactinfos" target="car_brand_id">
          <Datagrid>
            <TextField source="name" />
            <TextField source="type" />
            <TextField source="mobile" />
            <EditButton />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
      <Tab label="Sales Consultant">
        <ReferenceManyField
          addLabel={false}
          sort={{ field: 'full_name' }}
          reference="sales_advisors"
          target="car_brand_id"
        >
          <Datagrid>
            <FullNameField />
            <EmailField source="email" />
            <TextField source="mobile" />
            <ShowButton />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
      <Tab label="Service Consultant">
        <ReferenceManyField
          addLabel={false}
          sort={{ field: 'full_name' }}
          reference="service_consultants"
          target="car_brand_id"
        >
          <Datagrid>
            <FullNameField />
            <EmailField source="email" />
            <TextField source="mobile" />
            <ShowButton />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
    </TabbedShowLayout>
  </Show>
);

export const CarBrandCreate = props => (
  <Create title={<Title />} {...props}>
    <SimpleForm toolbar={<UploadToolbar source={['logo_url']} />} validate={validateMobile}>
      <TextInput source="name" validate={required()} />
      <TextInput source="email" type="email" />
      <TextInput source="mobile" />
      <TextInput source="default_user_sol" label="Account" />
      <TextInput source="default_password_sol" type="password" label="Password" />
      <TextInput source="community_id" label="Community ID" />
      <TextInput source="rooftop_id" label="Rooftop ID" />
      <TextInput source="partner_id" label="Partner ID" />
      <TextInput source="partner_key" label="Partner Key" />
      <TextInput source="partner_version" label="Partner Version" />
      <ImageInput source="qlogo_url" label="Logo" accept="image/jpeg,image/png" validate={required()}>
        <ImageField source="src" title="title" />
      </ImageInput>
      <PictureNote width="200" height="200" />
      <RichTextInput source="description" />
    </SimpleForm>
  </Create>
);

export const CarBrandEdit = EditForm;



// WEBPACK FOOTER //
// ./src/containers/CarBrand/index.js